import { ReportList } from '../dtos/Enums/ReportList';
import { reportItems } from './ReportNameList';

export class MultiPdfReportGroup {
  id: string;
  name: string;
  description?: string;
  reportKeys: string[];
  reportSequenceIds: ReportList[];
  type: 'standard' | 'local';
  createdAt?: Date;
  modifiedAt?: Date;
}

/**
 * Convert a comma-separated reportSequence string (IDs) to an array of report keys (names).
 * Uses the reportItems list to map ReportList enum IDs back to reportName keys.
 */
export function reportSequenceToKeys(reportSequence: string): string[] {
  if (!reportSequence) {
    return [];
  }
  const ids = reportSequence.split(',').map(id => Number(id.trim()) as ReportList);
  return ids
    .map(id => reportItems.find(item => item.id === id)?.reportName)
    .filter((name): name is string => !!name);
}

/**
 * Convert a comma-separated reportSequence string to an array of ReportList IDs.
 */
export function reportSequenceToIds(reportSequence: string): ReportList[] {
  if (!reportSequence) {
    return [];
  }
  return reportSequence.split(',').map(id => Number(id.trim()) as ReportList);
}

/**
 * Convert an array of report keys (names) to a comma-separated reportSequence string (IDs).
 * Uses the reportItems list to map reportName keys to ReportList enum IDs.
 */
export function reportKeysToSequence(reportKeys: string[]): string {
  if (!reportKeys || reportKeys.length === 0) {
    return '';
  }
  return reportKeys
    .map(key => reportItems.find(item => item.reportName === key)?.id)
    .filter((id): id is ReportList => id !== undefined)
    .join(',');
}
